<template>
  <div class="footer">
    <div class="quick-search-wrapper">
      <div class="container no-padding-h">
        <div class="row">
          <div class="col-sm-9 no-padding-h">
            <h4>Wyszukaj po tagach</h4>
            <div class="col-sm-12">
              <b-badge v-for="(item, index) in tags" :key="index" :to="'/product-tag/' + item.name" variant="dark">{{ item.name }}</b-badge>
            </div>
          </div>
          <div class="col-sm-3 no-padding-h">
            <h4>Dołącz do nas!</h4>
            <div class="col-sm-12 no-padding-h socials-wrapper">
              <div class="row">
                <div class="col-sm-12 col-md-4 no-padding-h social fb">
                  <div class="social-bg">
                    <a href="https://www.facebook.com/sharer.php?u=https%3A%2F%2Fveki.pl%2Fsklep%2F&t=SKLEP">
                      <div class="icon-wrapper">
                        <font-awesome-icon :icon="['fab', 'facebook-f']"/>
                        <font-awesome-icon :icon="['fab', 'facebook-f']"/>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 no-padding-h social pn">
                  <div class="social-bg">
                    <a href="https://pl.pinterest.com/zbigniewowsiak5/pins/">
                      <div class="icon-wrapper">
                        <font-awesome-icon :icon="['fab', 'pinterest-p']"/>
                        <font-awesome-icon :icon="['fab', 'pinterest-p']"/>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 no-padding-h social ig">
                  <div class="social-bg">
                    <a href="https://www.instagram.com/veki.organizujemy.szuflady/">
                      <div class="icon-wrapper">
                        <font-awesome-icon :icon="['fab', 'instagram']"/>
                        <font-awesome-icon :icon="['fab', 'instagram']"/>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="important-links-wrapper uppercase">
      <div class="container no-padding-h">
        <div class="row">
          <div class="col-sm-6 no-padding-h">
            <router-link to="/regulamin">regulamin sklepu</router-link>
          </div>
          <div class="col-sm-6 no-padding-h text-right">
            <router-link to="/polityka-prywatnosci">polityka prywatności</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright-wrapper">
      <div class="container no-padding-h">
        <div class="row">
          <div class="col-sm-10 no-padding-h">
            <div class="copyright">2019 © <strong>Veki.pl</strong>.</div>
          </div>
        </div>
      </div>
    </div>
    <div class="cookies" v-if="showCookiesWarning === 'true'">
      <p class="mb-0 pr-3">Ta strona używa ciasteczek (cookies), dzięki którym nasz serwis może działać lepiej.</p> <button class="btn btn-sm btn-outline-light uppercase" @click="toggleCookies">ok</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
		return {
      tags: [],
      showCookiesWarning: this.$cookies.get('cookies_warning') !== null ? this.$cookies.get('cookies_warning') : 'true'
		}
  },
  mounted() {
    this.$wcApi.fetchTags().then((data) => {
      for (let i = 0; i < data.length; i++) {
        const tag = data[i];
        if (tag.slug === 'generator') {
          continue;
        }

        this.tags.push(tag);
      }
    });
  },
  methods: {
    toggleCookies() {
      this.$cookies.set('cookies_warning', 'false');
      this.showCookiesWarning = 'false';
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~$scss/components/footer";
</style>